<script lang="ts">
  import { onMount } from 'svelte';
  import { MaterialApp, Dialog, ProgressCircular } from 'svelte-materialify';
  import Router from 'svelte-spa-router';
  import { settings, progress } from './store';
  import { routes, onRouteConditionsFailed } from './router';
  import Resolver from './lib/resolver';
  import Toast from './components/Toast.svelte';

  let resolving = true;

  onMount(async () => {
    await Resolver.resolve();
    resolving = false;
  });
</script>

<div id="app">
  {#if !resolving}
    <MaterialApp theme={$settings.theme}>
      <Router {routes} on:conditionsFailed={onRouteConditionsFailed} />
      <Toast />
      <Dialog
        class="ri-dialog d-flex justify-center"
        active={$progress.isActive}
        overlay={{ class: 'ri-overlay' }}
        persistent
      >
        <ProgressCircular size={120} width={7} indeterminate color="success" />
      </Dialog>
    </MaterialApp>
  {/if}
</div>

<style lang="scss">
  @import './styles/globals';

  #app {
    width: 100%;
    height: 100%;
  }
</style>
